import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'

export const createModalComplexProductMatrixStructureTPV = (subProducts: TwinDictionary[], variants: any, main: number): any => {
    const usedVariants = new Set<number>()
    let byVariantUsedId: TwinDictionary = {}
    let variantGroupValueTranslations: TwinDictionary = {}
    let variantGroupOrder: TwinDictionary = {}
    for (let element of subProducts) {
        const itemsForKey = []
        let id = 0
        const variantValues = element.ProductVariantGroup?.VariantValues
        for (let key in variantValues) {
            const item = variantValues[key]
            const isNotMainForHaveColumnApart = item.VariantGroupId !== main
            if (isNotMainForHaveColumnApart) {
                itemsForKey.push(item.id)
            } else {
                id = item.id
            }
            if (!variantGroupOrder[item.VariantGroupId]){
                variantGroupOrder[item.VariantGroupId] = []
            }
            if (!variantGroupValueTranslations[item.id]) {
                variantGroupValueTranslations[item.id] = {
                    name: variants?.variants[item.VariantGroupId].values[item.id].name,
                    parentName: variants?.variants[item.VariantGroupId].name,
                    parentId: item.VariantGroupId
                }
                variantGroupOrder[item.VariantGroupId].push({
                    order: item.order,
                    id: item.id
                })
            }
        }
        usedVariants.add(id)
        itemsForKey.unshift(id)
        let myItem = byVariantUsedId
        for (const key in itemsForKey) {
            let isLast = parseInt(key) === itemsForKey.length-1
            const myelement = itemsForKey[key]
            if (!myItem[myelement]) {
                myItem[myelement] = {
                    item: null,
                    nextItems: {},
                }
            }
            if (isLast) {
                myItem[myelement].item = element
            }
            myItem = myItem[myelement].nextItems
        }
    }
    return { byVariantUsedId, variantGroupValueTranslations, variantGroupOrder }
}